import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules'; 
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import 'swiper/css';
import './Category.css';
import 'swiper/css/navigation';

const Category = () => {
  
  const [heartStates, setHeartStates] = useState(new Array(10).fill(false)); // assuming 10 cards
  const navigate = useNavigate();

  const toggleHeart = (index) => {
    setHeartStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };

  const handleCategoryClick = () => {
    navigate('/category');
  };
  const handleCategoryDetailsClick = () => {
    navigate('/category-details');
  };

  return (
    <div className='mt-5 container-fluid'>
      <div className="d-flex gap-2 justify-content-between align-items-center px-3 mb-4">
        <img src="images/Group 75.png" className='category-title' alt="" />
        <div className="main-bg hovers px-3 py-2 text-white rounded-pill" onClick={handleCategoryClick}>See More</div>
      </div>
      <Swiper
        className='px-5'
        modules={[Navigation]} 
        navigation 
        spaceBetween={30} 
        breakpoints={{
          640: { slidesPerView: 1 }, 
          768: { slidesPerView: 2 }, 
          1024: { slidesPerView: 4 }
        }}
        loop
      >
        {Array(10).fill().map((_, index) => (
          <SwiperSlide key={index}>
            <div className="card p-3 rounded-4 h-100 position-relative">
              <img src="images/flower.png" className="category-img mb-2" alt="" />
              {heartStates[index] ? (
                <FontAwesomeIcon
                  icon={faHeart}
                  className="text-danger heart-icon position-absolute"
                  onClick={() => toggleHeart(index)}
                />
              ) : (
                <img
                  src="images/heart-thin.png"
                  className="heart-image position-absolute"
                  alt=""
                  onClick={() => toggleHeart(index)}
                />
              )}

              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="m-0 hovers" onClick={handleCategoryDetailsClick}>Lorem ipsum</h6>
                <h4 className="main-color m-0">$100</h4>
              </div>
              <p className="mb-2">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry Lorem Ipsum is simply dummy text of the printing and
                typesetting industry
              </p>
              <div className="d-flex justify-content-end">
                <img src="images/bi_cart.svg" className="hovers" alt="" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Category;
